import XLSX from 'xlsx';

const moment = require('moment');

const headers = [
  'name',
  'numberInProduct',
  'percentageShow',
  'ingredients',
  'numberInPatent',
  'roles',
  'claimed',
  'themes',
  'parentSegmentations',
  'subSegmentations',
];
const cols = [
  { width: 25 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
];

export default {
  methods: {
    async exportRelatedIncisView(relatedIncis, nbProducts) {
      // /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(
        await this.createXLSData(relatedIncis, nbProducts),
      );

      /* Set worksheet sheet to "wide" */
      ws['!margins'] = {
        left: 1.0,
        right: 1.0,
        top: 1.0,
        bottom: 1.0,
        header: 0.5,
        footer: 0.5,
      };
      ws['!cols'] = cols;

      let i;
      for (i in ws) {
        /* all keys that do not begin with "!" correspond to cell addresses */
        if (i.indexOf('!') === -1) {
          ws[i].s = {
            alignment: {
              wrapText: 1, // any truthy value here
            },
          };
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
      const fileName = `Export vue INCI liée_${moment().format('DD/MM/YYYY')}.xlsx`;
      /* generate file and send to client */
      XLSX.writeFile(wb, fileName);
    },
    async createXLSData(relatedIncis, nbProducts) {
      try {
        const data = [this.excelHeaders(nbProducts)];

        Object.entries(relatedIncis).forEach(([name, relatedInci]) => {
          data.push([
            name,
            relatedInci.numberInProduct,
            Math.round(relatedInci.percentageShow * 10000) / 100,
            this.getValuesFromOject(relatedInci.ingredients).join('; '),
            relatedInci.numberInPatent,
            this.getValuesFromOject(relatedInci.roles).join('; '),
            relatedInci.claimed,
            this.getValuesFromOject(relatedInci.themes).join('; '),
            this.getValuesFromOject(relatedInci.parentSegmentations).join('; '),
            this.getValuesFromOject(relatedInci.subSegmentations).join('; '),
          ]);
        });
        return data;
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    transformObjectToArray(relatedIncis) {
      const data = [];
      Object.entries(relatedIncis).forEach(([name, relatedInci]) => {
        data.push([
          name,
          relatedInci.numberInProduct,
          Math.round(relatedInci.percentageShow * 10000) / 100,
          this.getValuesFromOject(relatedInci.ingredients).join('; '),
          relatedInci.numberInPatent,
          this.getValuesFromOject(relatedInci.roles).join('; '),
          relatedInci.claimed,
          this.getValuesFromOject(relatedInci.themes).join('; '),
          this.getValuesFromOject(relatedInci.parentSegmentations).join('; '),
          this.getValuesFromOject(relatedInci.subSegmentations).join('; '),
        ]);
      });
      return data;
    },
    transformObjectToArrayV2(relatedIncis) {
      const data = [];
      Object.entries(relatedIncis).forEach(([name, relatedInci]) => {
        data.push([
          name,
          relatedInci.numberInProduct,
          Math.round(relatedInci.percentageShow * 10000) / 100,
          this.getValuesFromOjectV2(relatedInci.ingredients),
          relatedInci.numberInPatent,
          this.getValuesFromOjectV2(relatedInci.roles),
          relatedInci.claimed,
          this.getValuesFromOjectV2(relatedInci.themes),
          this.getValuesFromOjectV2(relatedInci.parentSegmentations),
          this.getValuesFromOjectV2(relatedInci.subSegmentations),
        ]);
      });
      return data;
    },
    getValuesFromOject(object) {
      const values = [];
      Object.entries(object).forEach(([name, value]) => {
        values.push(`${name} (${value})`);
      });
      return values;
    },
    getValuesFromOjectV2(object) {
      const values = [];
      Object.entries(object).forEach(([name, value]) => {
        values.push({ name, count: value });
      });
      return values;
    },
    excelHeaders(nbProducts) {
      const headerLabels = [];

      headers.forEach((header) => {
        headerLabels.push(
          header === 'numberInProduct' && nbProducts ? `${this.labels.exportRelatedIncisView[header]} - ${this.labels.export_total_product_selected.replace('%nb%', nbProducts)}` : this.labels.exportRelatedIncisView[header],
        );
      });
      return headerLabels;
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/exportRelatedIncisView.js